

<script lang="ts">
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import GhostButton from "../../../_shared/_modules/ghost-button"
  import type { OrganizationPresentation } from "../../../../api/public/presentation"
  import type { PublicAppointmentParticipantInput } from "../../../../api/public/appointment-portal"
  import type { PublicWorkOrder } from "../../../../api/public/work-orders"
  import type { AppointmentPortalContactMethodHints } from "../../_shared/_logic/contact-method-hints"
  import type { OrgPresentationMode } from "../../_shared/_logic/presentation-mode"
  import AppointmentPortal from "./_modules/appointment-portal"

  const {
    organization,
    loading,
    error,
    load,
    presentationMode = "appointment_portal_only",
    orgIdentifier,
    contactStepCode = null,
    contactMethodHints = null,
    onPortalCodeResolved = null,
    onContactMethodSubmitted = null,
  } = $props<{
    organization: OrganizationPresentation | null
    loading: boolean
    error: string | null
    load: () => Promise<void> | void
    presentationMode?: OrgPresentationMode
    orgIdentifier: string
    contactStepCode?: string | null
    contactMethodHints?: AppointmentPortalContactMethodHints | null
    onPortalCodeResolved?: ((code: string | null) => void) | null
    onContactMethodSubmitted?: ((participant: PublicAppointmentParticipantInput) => void) | null
    linkedOrder?: PublicWorkOrder | null
    orderLoading?: boolean
    orderError?: string | null
  }>()
</script>

{#if loading}
  <div class="state-block">
    <p>Profil wird geladen…</p>
  </div>
{:else if error}
  <div class="state-block">
    <p>{error}</p>
    <GhostButton onclick={load}>Erneut laden</GhostButton>
  </div>
{:else}
  <AppointmentPortal
    {organization}
    {orgIdentifier}
    {presentationMode}
    initialCode={contactStepCode}
    {contactMethodHints}
    oncodeResolved={onPortalCodeResolved}
    {onContactMethodSubmitted}
  />
{/if}

<style lang="less">
  .state-block {
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-wrap: wrap;

    p {
      margin: 0;
    }
  }
</style>
